import { Swiper } from "swiper";
import { Navigation, Autoplay } from "swiper/modules";

import "swiper/css";
import "swiper/css/navigation";

// Add to window
window.Swiper = Swiper;
window.Swiper_Navigation = Navigation;
window.Swiper_Autoplay = Autoplay;
